const DublicateIcon = ({ color }: any) => {
  return (
    <svg width={16} height={16} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g
        clipPath='url(#prefix__clip0)'
        stroke='#141A4D'
        strokeWidth={1.3}
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M13.333 5.999h-6C6.597 5.999 6 6.596 6 7.332v6c0 .737.597 1.334 1.333 1.334h6c.737 0 1.334-.597 1.334-1.334v-6c0-.736-.597-1.333-1.334-1.333z' />
        <path d='M3.334 9.999h-.667a1.333 1.333 0 01-1.333-1.334v-6a1.333 1.333 0 011.333-1.333h6a1.333 1.333 0 011.334 1.333v.667' />
      </g>
      <defs>
        <clipPath id='prefix__clip0'>
          <path fill='#fff' transform='translate(0 -.001)' d='M0 0h16v16H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DublicateIcon
